import { createContext, useContext } from "react"
import type { MonthlyCalculatorContextValue } from "./MonthlyCalculatorProvider"

export const MonthlyCalculatorContext = createContext<MonthlyCalculatorContextValue | undefined>(
  undefined,
)

export const useMonthlyCalculator = () => {
  const context = useContext(MonthlyCalculatorContext)

  if (!context) {
    throw new Error("useMonthlyCalculator must be used within a MonthlyCalculatorProvider")
  }

  return context
}
